import { css, Theme } from '@emotion/react'
import ReactMarkdown from 'react-markdown'
import { Box } from '@mui/material'
import { ArrowButton } from '~/components/atoms/ArrowButton'

type Props = {
  content: string
}

const NewsBody: React.FC<Props> = ({ content }) => {
  return (
    <>
      <Box mx={3} css={styles.bodyWrapper}>
        <div css={styles.content}>
          <ReactMarkdown children={content} />
        </div>
        <div>
          <ArrowButton url='news' label='一覧へ戻る' />
        </div>
      </Box>
    </>
  )
}

const styles = {
  bodyWrapper: css`
    display: grid;
    place-items: center;
    margin-bottom: 100px;
  `,
  content: (theme: Theme) => css`
    width: 100%;
    margin-bottom: 100px;
    text-align: left;
    & * {
      font-family: 'Noto sans JP', sans-serif;
    }
    & h2 {
      font-weight: 700;
      font-size: 1.2rem;
      padding: 0.4em 0.5em; /*文字の上下 左右の余白*/
      color: #494949; /*文字色*/
      background: #f4f4f4; /*背景色*/
      border-left: solid 5px #7db4e6; /*左線*/
      border-bottom: solid 3px #d7d7d7; /*下線*/
    }
    & h3 {
      position: relative;
      margin-left: 20px;
      font-weight: 700;
      font-size: 1.1rem;
      color: ${theme.palette.primary.main};
      &:before {
        content: '';
        position: absolute;
        margin-right: 10px;
        left: -20px;
        width: 6px;
        height: 100%;
        background-color: #15b4b4;
      }
    }
    & h4 {
      width: 80vw;
      max-width: 400px;
      position: relative;
      margin-left: 10px;
      font-weight: 700;
      font-size: 1rem;
      color: ${theme.palette.primary.main};
      &:before {
        content: '';
        position: absolute;
        width: 6px;
        bottom: -5px;
        height: 3px;
        width: 100%;
        background-color: #15b4b4;
      }
    }
    & p {
      font-size: 0.9rem;
      line-height: 1.7rem;
      letter-spacing: 0.1em;
      color: ${theme.palette.primary.main};
      margin-bottom: 30px;
    }
    & strong {
      background: linear-gradient(
        transparent 50%,
        rgba(255, 252, 107, 0.7) 50%
      );
    }
    & img {
      width: 100%;
      margin: 10px 0;
      box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
    }
    & ol {
      counter-reset: number; /*数字をリセット*/
      list-style-type: none !important; /*数字を一旦消す*/
      padding: 0.5em;
      background: #f5faff;
    }
    & ol li {
      position: relative;
      padding-left: 30px;
      line-height: 1.5em;
      padding: 0.5em 0.5em 0.5em 30px;
    }

    & ol li:before {
      /* 以下数字をつける */
      position: absolute;
      counter-increment: number;
      content: counter(number);
      /*以下数字のデザイン変える*/
      display: inline-block;
      background: #5c9ee7;
      color: white;
      font-family: 'Avenir', 'Arial Black', 'Arial', sans-serif;
      font-weight: bold;
      font-size: 15px;
      border-radius: 50%;
      left: 0;
      width: 25px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      /*以下 上下中央寄せのため*/
      top: 50%;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
    }
    & ul {
      border: solid 2px skyblue;
      border-radius: 5px;
      padding: 0.5em 1em 0.5em 2.3em;
      position: relative;
    }

    & ul li {
      color: ${theme.palette.primary.main};
      line-height: 1.5;
      padding: 0.5em 0;
      list-style-type: none !important;
    }

    & ul li:before {
      font-family: 'Font Awesome 5 Free';
      content: '\\f138'; /*アイコンの種類*/
      font-weight: 900;
      position: absolute;
      left: 1em; /*左端からのアイコンまでの距離*/
      color: skyblue; /*アイコン色*/
    }
    & th {
      background-color: #15b4b4;
      height: 40px;
      color: white;
    }
    & td {
      padding: 20px;
      color: ${theme.palette.primary.main};
      border-bottom: 1px dashed ${theme.palette.primary.main};
    }
  `,
  button: css`
    margin: 40px;
  `,
}

export default NewsBody
